import { faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'

export default function EditProfileDropdown({ diaperBank }: { diaperBank: DiaperBankPublic }) {
  const router = useRouter()
  return (
    <Menu as='div' className='relative inline-block text-left float-right'>
      <div>
        <Menu.Button className='dropdown-btn-with-icon'>
          <FontAwesomeIcon icon={faCog} />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='dropdown-items'>
          <div className='py-1'>
            <Menu.Item>
              {({ active }) => (
                <a href='#' onClick={() => router.push(`/bank/${diaperBank.slug}/edit`)} className={classNames('dropdown-item', { active })}>
                  Edit
                </a>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <a href='#' onClick={() => router.push(`/bank/${diaperBank.slug}?public=1`)} className={classNames('dropdown-item', { active })}>
                  See Public View
                </a>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
